import React from 'react';
import { FaStethoscope } from 'react-icons/fa';
import { Handle } from 'reactflow';
import { BsBraces } from 'react-icons/bs'; // NEW: Import icon for JSON output indicator

import { appImages } from '../../utils/constants';

// Sample data
// {
//   "app": "gmail",
//   "label": "Gmail",
//   "functions": [
//       "List Drafts",
//       "Create Draft",
//       "Update Draft",
//       "Send Email",
//       "Fetch User Files",
//       "Download and Save Attachments"
//   ],
//   "actionInstructions": "Test Instructions",
//   "outputExpectation": "Output Expectation"
// }

const ActionNode = ({ id, data }) => {
  const statusStyles = {
    idle: '',
    pending: 'border-yellow-400',
    queued: 'border-blue-400',
    failed: 'border-red-500',
    success: 'border-green-500',
    running: 'animate-[pulse_1s_infinite] border-green-500',
    approvalNeeded: 'animate-[glow_1.5s_infinite] border-orange-500',
    diagnosing: 'animate-[pulse_1s_infinite] border-purple-500', // 👈 new line
  };

  // Default to 'idle' if status is not provided or invalid
  const status = data?.status || 'idle';
  const isLoading =
    status === 'running' || status === 'pending' || status === 'diagnosing';

  // Check if there are improvement notes to display the icon.
  const hasImprovementNotes =
    Array.isArray(data?.improvement_notes_for_developer) &&
    data.improvement_notes_for_developer.length > 0;

  // NEW: Check if the node is configured to produce a structured JSON output.
  const hasJsonOutput = data?.jsonOutput === true;

  return (
    <div
      className={`relative w-72 rounded-lg border bg-zinc-800 text-zinc-100 shadow-md ${
        statusStyles[status] || ''
      }`}
    >
      {/* Animated border */}
      <div
        className={`pointer-events-none absolute inset-0 rounded-lg ${
          statusStyles[status] || ''
        }`}
      />

      {/* Header section with icon, title, and loading indicator */}
      <div className="flex items-center justify-between border-b border-zinc-700 p-3">
        <div className="flex items-center gap-2">
          {data?.label && (
            <img
              src={appImages[data?.app?.toLowerCase()]}
              alt="App icon"
              className="h-6 w-6"
            />
          )}
          <h3 className="text-md max-w-32 truncate font-semibold">
            {data?.label || 'Action'}
          </h3>
        </div>

        {/* {isLoading && (
          <div className="animate-spin h-4 w-4 border-2 border-zinc-500 border-t-white rounded-full" />
        )} */}
        {/* Container for right-side indicators */}
        <div className="flex items-center gap-2">
          {/* NEW: Improvement notes indicator icon */}
          {/* NEW: Indicator for structured JSON output */}
          {hasJsonOutput && (
            <div title="Structured JSON Output Enabled" className="cursor-help">
              <BsBraces className="h-4 w-4 text-cyan-400" />
            </div>
          )}
          {hasImprovementNotes && (
            <div
              title="Improvement suggestions available"
              className="cursor-help"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-yellow-400"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.21 3.03-1.742 3.03H4.42c-1.532 0-2.492-1.696-1.742-3.03l5.58-9.92zM10 13a1 1 0 110-2 1 1 0 010 2zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
          )}

          {/* Loading spinner */}
          {status === 'diagnosing' ? (
            <FaStethoscope className="animate-pulse text-purple-500" />
          ) : (
            isLoading && (
              <div className="h-4 w-4 animate-spin rounded-full border-2 border-zinc-500 border-t-white" />
            )
          )}
        </div>
      </div>

      {/* Instructions section */}
      {data?.actionInstructions && (
        <div className="p-3 text-xs">
          <p className="mb-1 text-xs font-medium text-zinc-400">
            Instructions:
          </p>
          <p className="line-clamp-3 text-zinc-100">
            {data.actionInstructions}
          </p>
        </div>
      )}

      {/* Connection handles */}
      <Handle
        type="target"
        position="left"
        className="border-none bg-yellow-400"
        style={{
          left: '-5px',
          top: '50%',
          transform: 'translateY(-50%)',
          height: '10px',
          width: '10px',
        }}
      />
      <Handle
        type="source"
        position="right"
        className="border-none bg-blue-400"
        style={{
          right: '-5px',
          top: '50%',
          transform: 'translateY(-50%)',
          height: '10px',
          width: '10px',
        }}
      />
    </div>
  );
};

export default ActionNode;
